import { useState, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import InvoiceCounter from "../../components/InvoiceCounter/InvoiceCounter";
import InvoicesTable from "../../components/InvoicesTable/InvoicesTable";
import Tabs from "../../components/Tabs/Tabs";
import { InvoicesContentWrapper, PageWrapper } from "./Invoices.styles";
import {
  openInvoices,
  updateInvoiceTableColumns,
  updateInvoiceTableHiddenColumns,
} from "../../activeScreenSlice";
import Performance from "../../components/Performance/Performance";
import { gridColumns } from "../../components/InvoicesTable/InvoicesTable.schema";
import { useInvoiceStatistics } from "../../hooks"
import { FilterValues } from "../../components/InvoicesTable/InvoiceFilterPanel";
import { GridSortModel } from "@mui/x-data-grid";

interface InvoicesI {
  userRole: string;
  filters:FilterValues,
  setFilters:(FilterValues)=>void
  filteredData:{},
  setFilteredData:(filters)=>void,
  setInvFilters:(invFilters)=>void,
  invFilters:{},
  sortModel: GridSortModel;
  setSortModel: React.Dispatch<React.SetStateAction<GridSortModel>>;
  paginationModel:{page:number,pageSize:number},
  setPaginationModel:(prev)=>void
}

export default function Invoices({ userRole,  filters,   setFilters,  filteredData,  setFilteredData,invFilters, setInvFilters,sortModel,setSortModel, paginationModel ,setPaginationModel}:InvoicesI) {
  const [tab, setTab] = useState("invoices");
  const [clearResultsClicked, setClearResultsClicked] = useState(false); // Track if "Clear Results" was clicked
  const [dateFilter, setDateFilter] = useState(null);
  const [activeCounterFilter, setActiveCounterFilter] = useState(null);
  const { data, isLoading } = useInvoiceStatistics(-1,invFilters);
  const [lastFilterSource, setLastFilterSource] = useState<string | null>(null); //  Track the last filter source
  const dispatch = useAppDispatch();

  const [invoiceCounts, setInvoiceCounts] = useState({
    invoice_count: 0,
    today: 0,
    oneToSevenDays: 0,
    eightToFifteenDays: 0,
    sixteenPlusDays: 0,
    outOfSLA: 0,
  });  

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    if (newValue === "home") {
      dispatch(openInvoices());
      return;
    }
    setTab(newValue);
  };

  const resetActiveFilter = () => setClearResultsClicked(true);

  const resetColumns = () => {
    dispatch(updateInvoiceTableColumns(gridColumns));
    dispatch(updateInvoiceTableHiddenColumns({}));
  };

  useEffect(() => {
  const storedFilter = localStorage.getItem("activeInvoiceCounterFilter");
  if (storedFilter) {
    setActiveCounterFilter(storedFilter);
    setLastFilterSource("counterClick"); //  Ensure the correct source is tracked
  }
}, []); //  Run only once on mount

useEffect(() => {
  if (clearResultsClicked) {
    setClearResultsClicked(false);
    setActiveCounterFilter(null);
    setLastFilterSource(null);
    localStorage.removeItem("activeInvoiceCounterFilter"); //  Ensure storage is cleared
  }
}, [clearResultsClicked]);   


  useEffect(() => {
    if (clearResultsClicked) {
      setClearResultsClicked(false);
      setActiveCounterFilter(null); //  Ensure counter UI resets
      setLastFilterSource(null); //  Reset filter source when clearing results
      localStorage.removeItem("activeInvoiceCounterFilter"); //  Clear stored filter
    }
  }, [clearResultsClicked]);   

  return (
    <PageWrapper>
      {/* Pass resetActiveFilter, setDateFilter, and tracking for UI number clicks */}
      <InvoiceCounter
        invoiceCounts={invoiceCounts || {
          invoice_count: 0,
          today: 0,
          oneToSevenDays: 0,
          eightToFifteenDays: 0,
          sixteenPlusDays: 0,
          outOfSLA: 0,
        }}
        resetActiveFilter={resetActiveFilter}
        clearResultsClicked={clearResultsClicked}
        setDateFilter={setDateFilter}
        setLastFilterSource={setLastFilterSource} //  Pass this to InvoiceCounter
        lastFilterSource={lastFilterSource} //  Pass this too
        invFilters={invFilters}
      />

      <Tabs
        value={tab}
        onChange={handleTabChange}
        userRole={userRole}
      />
      {tab === "invoices" && (
        <InvoicesContentWrapper>
          {/*  Allow `InvoicesTable` to update invoiceCounts, and check filter source */}
          <InvoicesTable
            resetActiveFilter={resetActiveFilter}
            dateFilter={dateFilter}
            totalInvoicesCount={data? data?.invoice_count : 0}
            setInvoiceCounts={setInvoiceCounts}
            lastFilterSource={lastFilterSource} //  Pass to InvoicesTable
            userRole={userRole}
            setInvFilters={setInvFilters}
            filters={filters}
            setFilters = {setFilters}
            filteredData={filteredData}
            setFilteredData={setFilteredData}
            sortModel={sortModel}
            setSortModel={setSortModel}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
          />
        </InvoicesContentWrapper>
      )}
      {(tab === "my-performance" || tab === "team-performance") && (
        <Performance type={tab === "my-performance" ? "individual" : "team"} />
      )}
    </PageWrapper>
  );
}
